export const ACTIVATE_FLEXI12_DASHBOARD = 'page/FLEXI12_DASHBOARD [activate]';
export const LEAVE_DASHBOARD = 'page/FLEXI12_DASHBOARD [leaving]';
